import { clsx } from 'clsx'
import { ReactNode } from 'react'

export function TabGroup({ children }: { children: ReactNode }) {
  return <nav className="flex flex-row justify-start border-b border-gray-300">{children}</nav>
}

export function Tab({
  selected,
  onClick,
  children,
  className
}: {
  selected?: boolean
  onClick?: () => void
  children: ReactNode
  className?: string
}) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'bg-white',
        selected ? 'text-blue-500' : 'text-gray-700',
        selected ? 'border-b-4 border-blue-500' : 'border-b-4 border-transparent',
        'min-w-0 px-2 py-2 text-center text-base',
        className
      )}
    >
      {children}
    </button>
  )
}
